import Icon from '../components/Icon.vue'

Icon.register({
  'universal-access': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 48c-115 0-208 93-208 208 0 115 93 208 208 208 115 0 208-93 208-208 0-115-93-208-208-208zM256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM256 64c106 0 192 86 192 192s-86 192-192 192-192-86-192-192 86-192 192-192zM256 108c-19.9 0-36 16.1-36 36s16.1 36 36 36 36-16.1 36-36-16.1-36-36-36zM373.7 206c8.6-2 13.9-10.6 11.9-19.2-2-8.6-10.6-13.9-19.2-11.9-96.5 22.8-124.1 22.8-220.8 0-8.6-2-17.2 3.3-19.2 11.9-2 8.6 3.3 17.2 11.9 19.2 28.7 6.8 55.5 12.7 82.1 15.8-0.9 101.1-12.3 123.1-25 155.6-3.6 9.3 1 19.7 10.2 23.3 9.3 3.6 19.7-1 23.3-10.2 8.7-22.3 17.1-40.7 22.3-78.5h9.7c5.2 37.9 13.6 56.2 22.3 78.5 3.6 9.3 14.1 13.8 23.3 10.2 9.3-3.6 13.8-14.1 10.2-23.3-12.7-32.6-24.2-54.6-25-155.6 26.6-3.1 53.4-9 82.1-15.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/universal-access.js
// module id = 2050
// module chunks = 0